module.exports = __webpack_public_path__ + "img/Cloud-Sun.534afba6.svg";